import {TicketInfoApiVo} from '../../common/shared/api/nicolas/vo/TicketInfoApiVo.interface';
import {TicketInfoApi, TicketKind} from '../generated/types';
import {createTicketType} from './TicketType';

export function createTicketInfoApi({
  movie_day,
  origin_price,
  paid_num,
  pkg_num,
  price,
  rent_expire_duration_min,
  series_id,
  series_title,
  ticket_id,
  ticket_type,
  total_num,
  vod_promotion_uid,
  vod_service_uid,
}: TicketInfoApiVo): TicketInfoApi {
  return {
    originPrice: origin_price,
    price,
    seriesId: series_id,
    seriesTitle: series_title,
    paidTicketCount: paid_num,
    totalTicketCount: total_num,
    discount: (price / paid_num) * (total_num - paid_num),
    isMovieDay: movie_day === 'Y',
    packageOrder: pkg_num,
    rentExpireDurationMin: rent_expire_duration_min,
    ticketId: ticket_id,
    ticketType: createTicketType(ticket_type),
    ticketKind: ticket_type.startsWith('TT') ? TicketKind.Own : TicketKind.Rent,
    vodPromotionUid: vod_promotion_uid,
    vodServiceUid: vod_service_uid,
  };
}
